import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTABand({ title = "Need a technician today?", sub = "One call dispatches a certified McCann and Sons technician anywhere in Central Louisiana — 24 hours a day." }) {
  return (
    <section data-testid="cta-band" className="bg-navy relative overflow-hidden grain-overlay">
      <div className="hero-grid-bg absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-20 lg:py-24 flex flex-col lg:flex-row lg:items-center gap-10">
        <div className="flex-1">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-frost mb-4">Fast Local Dispatch</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-white">
              {title}
            </h2>
            <p className="mt-5 text-slate-300 max-w-xl leading-relaxed">{sub}</p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="flex flex-col sm:flex-row lg:flex-col gap-4 shrink-0">
          <a
            data-testid="cta-band-call-btn"
            href="tel:3183122112"
            className="inline-flex items-center justify-center gap-2 bg-ember hover:bg-ember-dark text-navy-deep font-bold px-8 py-4 rounded-sm transition-all hover:-translate-y-0.5 active:scale-95"
          >
            <Phone className="h-4 w-4" />
            Call (318) 312-2112
          </a>
          <Link
            data-testid="cta-band-quote-btn"
            to="/contact"
            className="inline-flex items-center justify-center gap-2 border border-frost/60 text-frost hover:bg-frost hover:text-navy-deep font-bold px-8 py-4 rounded-sm transition-all hover:-translate-y-0.5 active:scale-95"
          >
            Request an Estimate
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
